import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ExternalSearchService } from '../../services/external-search.service';

@Component({
  selector: 'gen-external-search',
  templateUrl: 'external-search.component.html',
  styleUrls: ['external-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExternalSearchComponent implements OnInit {
  @Input() defaultButtonText: string;
  @Input() iconClass: string;
  @Input() searchURL: string;
  @Input() data: { [key: string]: string; };
  @Input() searchFormConfigParams: any;
  @Input() searchDataConfigParams: any;
  @Input() panelShown: boolean;
  public tag: string;
  private _panelButtonText: string;

  constructor(private externalSearchService: ExternalSearchService) { }

  ngOnInit() {
  }

  @Input() set panelButtonText(str: string) {
    this._panelButtonText = str;
    this.tag = str.replace(' ', '_');
  }

  get panelButtonText(): string {
    return this._panelButtonText;
  }

  dropdownVisibilityChanged(isVisible: boolean) {
    this.panelShown = isVisible;
  }

  buttonClick() {
    this.externalSearchService.runDefaultSearchQuery(this.searchURL, this.searchDataConfigParams,
      this.searchFormConfigParams, this.data);
  }
}
